function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M34.8,12.2c0,0.7-0.4,3.5-5,3.5c-4.7,0-5-2.9-5-3.5v-9h-3.1v12.4c0,0.3,0,0.6,0.5,1.2c0.5,0.5,1.2,0.4,1.2,0.4 h12.7c0,0,0.7,0,1.2-0.5s0.5-1.3,0.5-1.3V3.2h-3.1L34.8,12.2 M33,1.4h11.1l8.1,9.8V1.4h23v5.4H63.8v5.5c0,1.1,0.9,1.6,2.9,1.6 c2.6,0,3-1,3-1.6v-1.2h-2.5V9.3h7.9v6.3c0,0.9-0.3,1.7-1,2.5c-0.9,0.9-1.8,1-2.5,1H60.5c-0.7,0-1.6-0.1-2.5-1v-0.2V19h-6.6l-6.7-7.7 V19h-5.8v-1.1c0,0,0,0.1-0.1,0.1c-0.9,0.9-1.8,1-2.5,1H23.4c-0.7,0-1.6-0.1-2.5-1l-0.1-0.1L20.7,18c-0.9,0.9-1.8,1-2.5,1H7.1 c-0.7,0-1.6-0.1-2.5-1c-0.7-0.7-1-1.6-1-2.5V9.3H9v3c0,0.6,0.3,1.6,3,1.6c2,0,2.9-0.6,2.9-1.6V6.8H3.6V1.4h23v10.9 c0,0.6,0.5,1.6,3.2,1.6s3.2-1,3.2-1.6V1.4L33,1.4z M39.7,3.2v14h3.1v-9h1.5l7.9,9H57v-14h-3v11.1h-1.6L43.2,3.2H39.7z M73.3,3.2V5 H61.9v7.3c0,0.7,0.2,3.5,4.7,3.5c4.7,0,4.9-2.9,4.9-3.5v-1.2h1.8v4.3c0,0.4,0,0.9-0.3,1.2c-0.4,0.4-0.8,0.6-1.3,0.6H60.5 c0,0-0.8,0-1.3-0.7c-0.4-0.5-0.3-1.1-0.3-1.1V3.2H73.3L73.3,3.2z M5.4,3.2V5h11.4v7.3c0,0.7-0.2,3.5-4.7,3.5c-4.7,0-4.9-2.9-4.9-3.5 v-1.2H5.4v4.3c0,0.4,0,0.9,0.3,1.2C6.1,17,6.5,17.2,7,17.2h11.2c0,0,0.8,0,1.3-0.7c0.4-0.5,0.3-1.1,0.3-1.1V3.2H5.4L5.4,3.2z"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "78px",
    height: "20px",
    viewBox: "0 0 78 20",
    style: {
      enableBackground: "new 0 0 78 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c9840ca946460bb9efe069c79779c8fc.svg";
export { ForwardRef as ReactComponent };